// extracted by css-extract-rspack-plugin
export default {"merchantIcon":"s32fR4"};